import { animated } from 'react-spring';
import styled, { css } from 'styled-components';

export const DURATION = 350;
export const CardContainer = styled(animated.div)`
  ${({ theme: { colors }, zIndex }) => css`
    position: absolute;
    ${zIndex && `z-index: ${zIndex};`}
    display: flex;
    background-color: ${colors.background};
    border: 1px solid ${colors.whiteLine[100]};
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    user-select: none;
    overflow: hidden;
    touch-action: none;
  `}
`;

const getFrameContainerHeight = ({ device, dynamicWidth }) => {
  if (dynamicWidth >= 1300 || device === 'tablet') return '300px';
  if (dynamicWidth < 900 && dynamicWidth > 780) return '450px';

  return '430px';
};

export const FrameContainer = styled.div`
  position: relative;
  width: 100%;
  height: ${getFrameContainerHeight};
  min-width: 100%;
  z-index: 1;
`;

export const getCardContentContainerLayoutProps = ({
  dynamicWidth,
  isTabletLG,
  withCornerNumbers,
}) => {
  const paddingBasedOnCornerNumbers = withCornerNumbers ? 56 : 24;

  let px = 80;

  if (dynamicWidth < 1110 && dynamicWidth > 1024) {
    px = 40;
  } else if (dynamicWidth < 900 && dynamicWidth > 780) {
    px = 24;
  }

  return {
    flexDirection: 'column',
    height: '100%',
    pl: isTabletLG ? 24 : px,
    position: 'relative',
    pr: isTabletLG ? paddingBasedOnCornerNumbers : px,
    py: isTabletLG ? 24 : 40,
    width: '100%',
  };
};
